import PropTypes from 'prop-types';
import React from 'react';
import BestBetLabel from '../Icons/BestBetLabel';
import WorstBetLabel from '../Icons/WorstBetLabel';

const Bets = ({ bets }) => (
  <div className="sl-bets">
    <p className="sl-bets__header">Next 24 Hrs</p>
    {bets.best ? (
      <div className="sl-bets__bet">
        <BestBetLabel />
        {bets.best}
      </div>
    ) : null}
    {bets.worst ? (
      <div className="sl-bets__bet">
        <WorstBetLabel />
        {bets.worst}
      </div>
    ) : null}
  </div>
);

Bets.propTypes = {
  bets: PropTypes.shape({
    best: PropTypes.string,
    worst: PropTypes.string,
  }).isRequired,
};

export default Bets;
